import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";


// Ganti dengan konfigurasi Firebase Anda
const firebaseConfig = {
    apiKey: "AIzaSyCiWSscwMI5hQgrmODSTJjOvE0Vz87NFCI",
    authDomain: "form-order-7c81d.firebaseapp.com",
    projectId: "form-order-7c81d",
    storageBucket: "form-order-7c81d.firebasestorage.app",
    messagingSenderId: "632118480939",
    appId: "1:632118480939:web:b2234c3415765665789a6e"  
};

// Inisialisasi Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, addDoc };
export const auth = getAuth(app);

